import { FC, useEffect, useState } from 'react';

import { useSession } from '~components/hooks/useSession';
import { secondaryColors } from '~components/theme/styles/colors';

import { ButtonWithIcon } from '../../buttons/buttonWithIcon';
import { useAccountDial } from '../provider';
import { DialOptions } from '../types';

export const AccountDialConnectionButtons: FC<{ onDisconnect: () => void }> = ({ onDisconnect }) => {
  const [showConnectButton, setShowConnectButton] = useState<boolean>(false);
  const [buttonContent, setButtonContent] = useState<string>('CONNECT');
  const [hovered, setHovered] = useState(false);

  const { isConnected, disconnect, address } = useSession();
  const dialCtx = useAccountDial();

  useEffect(() => {
    setShowConnectButton(!isConnected);
    setButtonContent(isConnected ? address.slice(0, 4) + '...' + address.slice(-4) : 'CONNECT');
  }, [isConnected]);

  return (
    <ButtonWithIcon
      sx={{
        zIndex: 1000,
        minWidth: 180,
        maxWidth: 180,
        maxHeight: 40,
        color: secondaryColors[500],
      }}
      variant={'primary'}
      iconType={showConnectButton ? 'in' : 'out'}
      onClick={e => {
        if (showConnectButton) {
          dialCtx.switchDialContent(DialOptions.CONNECTION);
        } else {
          e.stopPropagation();
          dialCtx.resetAll();
          onDisconnect();
          disconnect();
        }
      }}
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => {
        setHovered(false);
      }}
    >
      {isConnected && hovered ? 'DISCONNECT' : buttonContent}
    </ButtonWithIcon>
  );
};
